module.exports = __webpack_public_path__ + "static/media/SortNew.e4a18ada.svg";